// src/components/StateButton.js
import "./StateButton.css";

export default function StateButton({ label, visited, onClick }) {
  return (
    <button
      className={`state-button ${visited ? "visited" : "not-visited"}`}
      onClick={visited ? onClick : undefined}
      disabled={!visited}
    >
      {label}
    </button>
  );
}
